<template>
    <section>
        <div class="annexDetailShow">
            <el-form ref="AnnexForm" :model="annexDetailList" label-width="130px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="附件名称">
                            <el-input v-model="annexDetailList.zcmc" readonly size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="出厂编号">
                            <el-input v-model="annexDetailList.ccbh" readonly size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="测量范围">
                            <el-input v-model="annexDetailList.clfw" readonly size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="检定/校准类型">
                            <el-input v-model="annexDetailList.jdlx" readonly size="small"
                                :formatter="formatJdlx"></el-input>
                        </el-form-item>
                        <el-form-item label="检定/校准日期">
                            <el-input v-model="annexDetailList.jdrq" readonly size="small"
                                :formatter="formatJdlx"></el-input>
                        </el-form-item>
                        <el-form-item label="录入人">
                            <el-input v-model="annexDetailList.lrr" readonly size="small"
                                :formatter="formatJdlx"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="管理编号">
                            <el-input v-model="annexDetailList.glbh" readonly size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="采购日期">
                            <el-input v-model="annexDetailList.cgrq" readonly size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="测量精度">
                            <el-input v-model="annexDetailList.cljd" readonly size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="检定周期">
                            <el-input v-model="annexDetailList.jdzq" readonly size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="下次检定/校准日期">
                            <el-input v-model="annexDetailList.xcjdrq" readonly size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="录入日期">
                            <el-input v-model="annexDetailList.lrrq" readonly size="small"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-collapse v-model="activeName">
                <el-collapse-item name="checkInfo">
                    <template slot="title" class="collapse-title">
                        <span style="margin-left:10px">检定/校准</span>
                    </template>
                    <el-row style="margin-top:15px;margin-left:10px">
                        <el-table :data="annexCheckList" style="width: 100%"
                            :default-sort="{ prop: 'date', order: 'descending' }">
                            <el-table-column type="index" label="序号">
                            </el-table-column>
                            <el-table-column prop="id" label="检定/校准单号" sortable  show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column prop="checkCompany" label="检定/校准单位" sortable  show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column prop="checkCertificate" label="检定/校准证书号" sortable width="150" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column prop="checkTime" label="检定/校准日期" sortable  show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column prop="jdlx" label="类型" sortable show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <span v-if="scope.row.jdlx == 0">检定</span>
                                    <span v-if="scope.row.jdlx == 1">校准</span>
                                    <span v-if="scope.row.jdlx == 2">外部校准</span>
                                </template>
                            </el-table-column>
                            
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <el-link :underline="false" style="color: #4095E5;text-decoration: none;"
                                        @click="toCheckDetail(scope.row)">详情 </el-link>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-row>
                </el-collapse-item>
            </el-collapse>
        </div>
    </section>
</template>
<script>
import { selectAnnexByid } from "../../../api/api"
export default {
    data() {
        return {
            annexDetailList: [],
            annexCheckList: [],
            activeName: "checkInfo"
        }
    },
    props: ['annexId'],
    methods: {
        getAnnexDetail() {
            let _params = {
                id: this.annexId
            }
            selectAnnexByid(_params).then(resultData => {
                let { data, status, message } = resultData;
                if (status == 200) {
                    this.annexDetailList = data[0];
                    debugger


                    if (data[0].jdlx == 0) {
                        this.annexDetailList.jdlx = "检定"
                    }
                    if (data[0].jdlx == 1) {
                        this.annexDetailList.jdlx = "设备核查"
                    }
                    if (data[0].jdlx == 1) {
                        this.annexDetailList.jdlx = "校准"
                    }
                    if (data[0].jdlx == 1) {
                        this.annexDetailList.jdlx = "不检定/校准"
                    }


                    this.annexCheckList = data[0].checkList
                }
            })
        },
        formatJdlx(row) {
            console.log("row", row)
        },
        toCheckDetail(row){
            let jdlx=row.jdlx
            sessionStorage.setItem("id",row.id)
            let userinfo=JSON.parse(localStorage.getItem("user")) 
            let userRoles=userinfo.role.menuId
            if(jdlx==0){//检定
                if(userRoles.indexOf("151")==-1){
                    this.$message({message: "你没有权限访问该页面",type: 'warning'});
                }else{
                    this.$router.push({
                        path: "particulars"
                    });
                }
            }
            if(jdlx==1){//内部校准
                if(userRoles.indexOf("180")==-1){
                    this.$message({message: "你没有权限访问该页面",type: 'warning'});
                }else{
                    this.$router.push({
                        path: "correctingParticulars"
                    });
                }
            }
            if(jdlx==2){//外部校准
                if(userRoles.indexOf("177")==-1){
                    this.$message({message: "你没有权限访问该页面",type: 'warning'});
                }else{
                    this.$router.push({
                        path: "calibrationParticulars"
                    });
                }
            }
          }
    },
    created() {
        this.getAnnexDetail();
    }
}
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/views/device/components/AnnexDetail.vue